import { Event } from './event.js';
import { Base64 } from 'js-base64';

export class Box extends Event {
    constructor(element) {
        super();
        this._element = element;
        this._config = this._element.querySelector('.config');
        this._json = {};
        this._checkbox = this._element.querySelector('input[type="checkbox"]');
        this._holder = this._element.parentNode;
        this._request = false;
        this._prefill = false;
    };
    
    get id() {
        return this._element.dataset.id || 0;
    }

    get prefill() {
        return this._prefill || false;
    }

    get isSelected() {
        return this._element.classList.contains('activedevice');
    }

    set prefill(value) {
        this._prefill = value;
    }
    
    init() {
        if(this._config) {
            this._json = JSON.parse(Base64.decode(this._config.dataset.config));
            this._config.remove();
        }
    }
    
    select() {
        if(this._checkbox) {
            this._checkbox.checked = true;
        }

        this.toggleButton(this._element, true);
        this.fireEvent(this._trackType + 'SelectEnd');
    }
    
    unselect() {
        if(this._checkbox) {
            this._checkbox.checked = false;
        }
        
        this.toggleButton(this._element, false);
        this.fireEvent(this._trackType + 'UnselectEnd');
    }
    
    show() {
        this._holder.classList.remove('d-none');
    }
    
    hide() {
        this._holder.classList.add('d-none');
    }
    
    toggleButton(element, show) {
        let label = element.querySelector('span');
        let btn1 = element.querySelector('.s0');
        let btn2 = element.querySelector('.s1');
        
        (show) ? label.classList.add('actborder') : label.classList.remove('actborder');
        (show) ? this._element.classList.add('activedevice') : this._element.classList.remove('activedevice');
        (show) ? this._element.classList.remove('inactivedevice') : this._element.classList.add('inactivedevice');
        if(btn1) {
            (show) ? btn1.classList.add('d-none') : btn1.classList.remove('d-none');
        }
        if(btn2) {
            (show) ? btn2.classList.remove('d-none') : btn2.classList.add('d-none');
        }
    };
    
    trackEvent(steps, maxSteps) {
        Tracking.customEvent('checkout_' + this._trackType, {
            product_name: this.title,
            event_category: 'checkout',
            event_action: this._trackType, 
            event_label: this.title,
            step: steps,
            maxStep: maxSteps,
            prefilled: this.prefill,
        });
        this.prefill = false;
    }
}
